import type { FC, PropsWithChildren } from 'react'
import { useMemo } from 'react'

import { Axis } from './Axis'
import { LegendContext } from './context'
import { Gradient } from './Gradient'
import { Header } from './Header'
import { Histogram } from './Histogram'
import type { LegendContextType, LegendProps } from './types'

const LegendBase: FC<PropsWithChildren<LegendProps>> = ({
  children,
  height,
  width,
  attribute,
  className,
  entityId,
  palette,
}) => {
  const context = useMemo<LegendContextType>(
    () => ({
      attribute,
      entityId,
      isHorizontal: width > height,
      height,
      width,
      palette,
    }),
    [height, width, attribute, entityId, palette],
  )

  return (
    <LegendContext.Provider value={context}>
      <div className={className}>{children}</div>
    </LegendContext.Provider>
  )
}

export const CommonLegend = Object.assign(LegendBase, {
  Header,
  Gradient,
  Axis,
  Histogram,
})
